'use strict';

class BillingPlanController {
  constructor($log,
              $scope,
              $rootScope,
              $q,
              $timeout,
              $filter,
              $state,
              $stateParams,
              utils,
              config,
              VirtualPaginator,
              ToastsService) {

    // #region Define fields

    const $t = $filter('translate');
    const SELECTED_ORG_LOCAL_STORAGE_KEY = 'Selected-Org';
    const SELECTED_BILLING_PLAN_LOCAL_STORAGE_KEY = 'Selected-Billing-Plan';

    $scope.loading = true;
    $scope.billingPlanPage = {};
    let $billingPlanPage = $scope.billingPlanPage;

    angular.extend($scope, {
      back: back,
    });

    // Navigaiton Tabs
    $billingPlanPage.tabs = [
      {
        id: 'details',
        name: $t('form.details'),
        icon: 'far fa-file-alt'
      }, {
        id: 'versions',
        name: $t('bots.bundle'),
        icon: 'iotr fa-bot',
        hidden: true,
      },
    ];

    init();

    function init() {
      $billingPlanPage.billingPlan = utils.getStorageItem(SELECTED_BILLING_PLAN_LOCAL_STORAGE_KEY);
      console.log($billingPlanPage.billingPlan);
      $scope.loading = false;
    }

    function back() {
      let targetRoute = 'main.organizations.edit';
      $state.go(targetRoute, {
        tab: 'billing'
      });
    }

  }
}

export default angular
  .module('main.billingPlan.controller', [])
  .controller('BillingPlanController', BillingPlanController)
  .name;
